import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { StickyContainer, Sticky } from 'react-sticky';
import { calculateRem } from '@uie/javascript-style-helpers';
import { getBackgroundColor } from './accordionUtil';
import { withVDSManager } from '@vds-core/utilities';
import { colors, calculateSpacing } from '@vds-core/theme';
var propTypes = {
  /**
   * @ignore
   */
  backgroundColor: PropTypes.string,

  /**
   * Children for the AccordionItem can only be AccordionHeader or AccordionDetail.
   */
  children: PropTypes.node.isRequired,

  /**
   * @deprecated
   */
  className: PropTypes.string,
  //DEPRECATED

  /**
   * @deprecated onClick
   */
  clickHandler: PropTypes.func,
  // DEPRECATED

  /**
   * @ignore
   */
  onClick: PropTypes.func,

  /**
   * @ignore
   */
  activeID: PropTypes.string,

  /**
   * @ignore
   */
  groupIndex: PropTypes.number,

  /**
   * @ignore
   */
  groupId: PropTypes.string,

  /**
   *	When true, text will be changed to a color of white. When using the inverted prop Accordion must be in a container element with a black background.
   */
  inverted: PropTypes.bool,

  /**
   * @deprecated opened
   */
  show: PropTypes.bool,
  //DEPRECATED

  /**
   * Use prop to programmatically control if the AccordionItem is open or closed.
   */
  opened: PropTypes.bool,

  /**
   * @deprecated type
   */
  single: PropTypes.bool,

  /**
   * @ignore
   */
  type: PropTypes.oneOf(['single', 'multi']),

  /**
   * Use prop to programmatically control if the AccordionItem is sticky when open and scrolled to the top of the page.
   */
  sticky: PropTypes.bool,

  /**
   * @ignore
   */
  testMode: PropTypes.bool,

  /**
   * @ignore
   */
  borderBottom: PropTypes.bool,

  /**
   * @ignore - Turn off bottom padding here when the header hit area is on / needs to extend to the bottom of the wrapper when collapsed
   */
  buttonHitArea: PropTypes.bool,

  /**
   * When true, the drawer will remain open and not be able to close.
   */
  alwaysOpen: PropTypes.bool,

  /**
   * @ignore
   */
  linkStandalone: PropTypes.bool,

  /**
   * @ignore Object containing colors
   */
  colorConfig: PropTypes.object,

  /**
   * @ignore
   */
  focusState: PropTypes.bool,

  /**
   * @ignore
   */
  mediumIcon: PropTypes.bool,

  /**
   * @ignore
   */
  transitionStates: PropTypes.bool,

  /**
   * @ignore
   */
  triggerActiveAnimation: PropTypes.bool,

  /**
   * @ignore
   */
  triggerHeight: PropTypes.number,

  /**
   * @ignore
   */
  activeState: PropTypes.bool,

  /**
   * @ignore
   */
  caretAnimation: PropTypes.bool,

  /**
   * @ignore
   */
  caretTrigger: PropTypes.bool
};
var defaultProps = {
  backgroundColor: null,
  className: null,
  //DEPRECATED
  onClick: function onClick() {},
  activeID: null,
  groupIndex: 1,
  groupId: null,
  inverted: false,
  show: false,
  //DEPRECATED
  opened: false,
  single: false,
  type: 'multi',
  sticky: false,
  testMode: false,
  alwaysOpen: false,
  //1.0
  borderBottom: false,
  buttonHitArea: false,
  focusState: false,
  triggerHeight: undefined,
  activeState: false,
  caretTrigger: false,
  mediumIcon: false,
  caretAnimation: false,
  transitionStates: false,
  triggerActiveAnimation: false,
  colorConfig: colors,
  linkStandalone: false
};
var StyledAccordionItem = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledAccordionItem",
  componentId: "sc-h2bqgc-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  padding-bottom: ", ";\n  border-bottom: ", ";\n"])), function (props) {
  return getBackgroundColor(props);
}, function (_ref) {
  var buttonHitArea = _ref.buttonHitArea;
  return buttonHitArea ? '1px' : calculateSpacing('6X', 'px');
}, function (_ref2) {
  var borderBottom = _ref2.borderBottom,
      colorConfig = _ref2.colorConfig,
      inverted = _ref2.inverted;
  return borderBottom ? '1px solid ' + (inverted ? colorConfig.white : colorConfig.black) : 'none';
});

var AccordionItem = /*#__PURE__*/function (_Component) {
  _inherits(AccordionItem, _Component);

  var _super = _createSuper(AccordionItem);

  function AccordionItem() {
    var _this;

    _classCallCheck(this, AccordionItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "accordionDetailElement", false);

    _defineProperty(_assertThisInitialized(_this), "state", {
      active: _this.props.alwaysOpen ? true : _this.props.show || _this.props.opened
    });

    _defineProperty(_assertThisInitialized(_this), "deactivateGroup", function () {
      _this.setState(function () {
        return {
          active: false
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleGroup", function () {
      _this.setState(function (_ref3) {
        var active = _ref3.active;
        return {
          active: _this.props.alwaysOpen ? true : !active
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_clickHandler", function (e, childClick) {
      childClick && childClick(e); // Toggle if this AccordionItem is open/closed, and tell parent Accordion

      _this.toggleGroup();

      if (_this.props.clickHandler && _this.props.groupId) _this.props.clickHandler(_this.props.groupId);
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (e, childClick) {
      childClick && childClick(e, !_this.state.active);

      _this.toggleGroup();

      if (_this.props.onClick && _this.props.groupId) _this.props.onClick(_this.props.groupId);
    });

    _defineProperty(_assertThisInitialized(_this), "renderDetail", function (childElement, index) {
      var _this$props = _this.props,
          groupId = _this$props.groupId,
          inverted = _this$props.inverted,
          borderBottom = _this$props.borderBottom,
          buttonHitArea = _this$props.buttonHitArea,
          transitionStates = _this$props.transitionStates,
          calcTypography = _this$props.calcTypography,
          colorConfig = _this$props.colorConfig;
      return /*#__PURE__*/React.cloneElement(childElement, {
        key: index + 1,
        alwaysOpen: _this.props.alwaysOpen,
        active: _this.props.alwaysOpen || _this.state.active,
        backgroundColor: childElement.props.backgroundColor ? childElement.props.backgroundColor : getBackgroundColor(_this.props),
        groupId: groupId,
        inverted: inverted,
        borderBottom: borderBottom,
        buttonHitArea: buttonHitArea,
        transitionStates: transitionStates,
        calcTypography: calcTypography,
        colorConfig: colorConfig
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderSummary", function (childElement, index) {
      var _this$props2 = _this.props,
          groupIndex = _this$props2.groupIndex,
          groupId = _this$props2.groupId,
          inverted = _this$props2.inverted,
          sticky = _this$props2.sticky,
          testMode = _this$props2.testMode,
          borderBottom = _this$props2.borderBottom,
          calcTrigger = _this$props2.calcTrigger,
          typescale = _this$props2.typescale,
          calcTypography = _this$props2.calcTypography,
          buttonHitArea = _this$props2.buttonHitArea,
          focusState = _this$props2.focusState,
          triggerHeight = _this$props2.triggerHeight,
          triggerSize = _this$props2.triggerSize,
          activeState = _this$props2.activeState,
          caretTrigger = _this$props2.caretTrigger,
          iconData = _this$props2.iconData,
          mediumIcon = _this$props2.mediumIcon,
          caretAnimation = _this$props2.caretAnimation,
          transitionStates = _this$props2.transitionStates,
          triggerActiveAnimation = _this$props2.triggerActiveAnimation,
          colorConfig = _this$props2.colorConfig,
          linkStandalone = _this$props2.linkStandalone,
          bodyConfig = _this$props2.bodyConfig,
          cta = _this$props2.cta,
          level = _this$props2.level,
          position = _this$props2.position,
          dataTrack = _this$props2.dataTrack,
          topLineType = _this$props2.topLineType;

      var _ref4 = childElement && childElement.props,
          _onClick = _ref4.onClick,
          clickHandler = _ref4.clickHandler,
          analyticsTrack = _ref4['data-analyticstrack'],
          track = _ref4['data-track'],
          clickStream = _ref4['data-clickstream']; // Check if we are Rendering a Sticky AccordionHeader


      if (sticky) {
        return /*#__PURE__*/React.createElement(Sticky, {
          topOffset: 0
        }, function (_ref5) {
          var style = _ref5.style;
          return /*#__PURE__*/React.cloneElement(childElement, {
            key: index + 1,
            alwaysOpen: _this.props.alwaysOpen,
            active: _this.state.active,
            backgroundColor: childElement.props.backgroundColor ? childElement.props.backgroundColor : getBackgroundColor(_this.props),
            clickHandler: clickHandler ? function (e) {
              _this._clickHandler(e, clickHandler);
            } : undefined,
            onClick: function onClick(e, x) {
              _this._onClick(e, x, _onClick);
            },
            groupIndex: groupIndex,
            groupId: groupId,
            inverted: inverted,
            style: style,
            sticky: sticky,
            testMode: testMode,
            borderBottom: borderBottom,
            buttonHitArea: buttonHitArea,
            calcTrigger: calcTrigger,
            typescale: typescale,
            calcTypography: calcTypography,
            focusState: focusState,
            triggerHeight: triggerHeight,
            triggerSize: triggerSize,
            activeState: activeState,
            caretTrigger: caretTrigger,
            iconData: iconData,
            mediumIcon: mediumIcon,
            caretAnimation: caretAnimation,
            transitionStates: transitionStates,
            triggerActiveAnimation: triggerActiveAnimation,
            colorConfig: colorConfig,
            linkStandalone: linkStandalone,
            bodyConfig: bodyConfig,
            clickStream: clickStream,
            analyticsTrack: analyticsTrack,
            track: track,
            dataTrack: dataTrack,
            cta: cta,
            position: position,
            level: level,
            topLineType: topLineType
          });
        });
      } // Render AccordionHeader without Sticky wrapper


      return /*#__PURE__*/React.cloneElement(childElement, {
        key: index + 1,
        alwaysOpen: _this.props.alwaysOpen,
        active: _this.state.active,
        clickStream: clickStream,
        analyticsTrack: analyticsTrack,
        track: track,
        dataTrack: dataTrack,
        cta: cta,
        position: position,
        level: level,
        backgroundColor: childElement.props.backgroundColor ? childElement.props.backgroundColor : getBackgroundColor(_this.props),
        clickHandler: clickHandler ? function (e) {
          _this._clickHandler(e, clickHandler);
        } : undefined,
        onClick: function onClick(e) {
          _this._onClick(e, _onClick);
        },
        groupIndex: groupIndex,
        groupId: groupId,
        inverted: inverted,
        borderBottom: borderBottom,
        buttonHitArea: buttonHitArea,
        calcTrigger: calcTrigger,
        typescale: typescale,
        calcTypography: calcTypography,
        focusState: focusState,
        triggerHeight: triggerHeight,
        triggerSize: triggerSize,
        activeState: activeState,
        caretTrigger: caretTrigger,
        iconData: iconData,
        mediumIcon: mediumIcon,
        caretAnimation: caretAnimation,
        transitionStates: transitionStates,
        triggerActiveAnimation: triggerActiveAnimation,
        colorConfig: colorConfig,
        linkStandalone: linkStandalone,
        bodyConfig: bodyConfig,
        topLineType: topLineType
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderGroup", function () {
      var _this$props3 = _this.props,
          backgroundColor = _this$props3.backgroundColor,
          children = _this$props3.children,
          className = _this$props3.className,
          groupId = _this$props3.groupId,
          inverted = _this$props3.inverted,
          alwaysOpen = _this$props3.alwaysOpen,
          borderBottom = _this$props3.borderBottom,
          buttonHitArea = _this$props3.buttonHitArea,
          colorConfig = _this$props3.colorConfig;
      return /*#__PURE__*/React.createElement(StyledAccordionItem // aria-expanded={this.state.active}
      , {
        backgroundColor: backgroundColor,
        className: className,
        groupId: groupId,
        inverted: inverted,
        borderBottom: borderBottom,
        buttonHitArea: buttonHitArea,
        colorConfig: colorConfig
      }, React.Children.map(children, function (child, index) {
        // Accordion Children can have a React.Fragment wrapper
        // If so, we need to strip it off
        var childElement = child.type === React.Fragment ? child.props.children : child;
        childElement = childElement instanceof Array ? childElement[0] : childElement; // We only want to save Refs to AccordionHeader and AccordionItem

        var childType = childElement.type.componentType ? childElement.type.componentType : '';

        if (childType === 'AccordionHeader') {
          return _this.renderSummary(childElement, index);
        }

        if (childType === 'AccordionDetail') {
          return _this.renderDetail(childElement, index);
        } // If not an Accordion Component, just return the childElement


        return childElement;
      }));
    });

    return _this;
  }

  _createClass(AccordionItem, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var activeID = prevProps.activeID,
          single = prevProps.single,
          type = prevProps.type;
      var open = this.props.alwaysOpen ? true : this.props.show || this.props.opened;

      if ((single || type === 'single') && this.props.activeID !== activeID && prevState.active && !this.props.alwaysOpen) {
        this.deactivateGroup();
      }

      if (typeof open !== 'undefined' && (this.props.show !== prevProps.show || this.props.opened !== prevProps.opened)) {
        this.setState({
          active: this.props.show || this.props.opened
        });
        this.props.onClick && this.props.onClick(this.props.groupId);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          groupId = _this$props4.groupId,
          sticky = _this$props4.sticky,
          testMode = _this$props4.testMode;

      if (sticky) {
        return /*#__PURE__*/React.createElement(StickyContainer, {
          "data-testid": testMode ? "stickycontainer_".concat(groupId) : undefined,
          "sticky-div": "stickyDiv"
        }, this.renderGroup());
      }

      return this.renderGroup();
    }
  }]);

  return AccordionItem;
}(Component);

_defineProperty(AccordionItem, "componentType", 'AccordionItem');

AccordionItem.propTypes = propTypes;
AccordionItem.defaultProps = defaultProps;
export default AccordionItem;